<router-outlet></router-outlet>
<app-message-box></app-message-box>
<app-loading-spinner></app-loading-spinner>
<app-tailwind-toast-message class="fixed top-16 right-[90px] z-[99]"></app-tailwind-toast-message>
<app-ribbon [environment]="environment"></app-ribbon>
